export default {
  confirm: '確定',
  cancel: '取消',
  delete: '刪除',
  disable: '停用',
  enable: '啟用',
  preview: '預覽',
  add: '新增',
  edit: '編輯',
  copy: '複製',
  mobile: '手機',
  save: '儲存',
  pleaseChoose: '請選擇',
  noRecord: '查無資料'
};
